import { exportUnsyncedEvents } from '@gmao/sync';

export async function downloadUnsyncedEvents(missionId?: string) {
  const url = URL.createObjectURL(
    new Blob([await exportUnsyncedEvents(missionId)], { type: 'application/json' }),
  );
  const link = document.createElement('a');
  link.href = url;
  link.download = `gmao-unsent-events-${new Date().toISOString().slice(0, 10)}.json`;
  link.click();
  URL.revokeObjectURL(url);
}
